import { environment } from 'src/environments/environment';
import { api } from 'src/app/models/api-url.model';

import { HOURS, SECOND } from '../../../shared/functions/time';

export const SESSION_SECONDS = {
  REMEMBER_ME: HOURS(48) / SECOND,
  DEFAULT: HOURS(2) / SECOND,
};

export const URLS = {
  LOGIN: `${environment.apiUrl}${api.loginURL}`,
  IMPERSONATION: `${environment.apiUrl}${api.impersonateURL}`,
  FORGOT_PASSWORD: `${environment.apiUrl}${api.requestPasswordResetURL}`,
  REGISTER: `${environment.apiUrl}${api.registerURL}`,
  RESET_PASSWORD: `${environment.apiUrl}${api.resetPasswordURL}`,
  VALIDATE_PASSWORD: `${environment.apiUrl}${api.validateTokenURL}`,
  LOGIN_OKTA_USER: `${environment.apiUrl}${api.loginOktaURL}`,
};
